import React, { useContext, useMemo } from 'react';
import { MultiScreenReceiver } from '../controllers/MultiScreenReceiver';

const MultiScreenReceiverContext = React.createContext<MultiScreenReceiver | undefined>(undefined);

export function useMultiScreenReceiver() {
    return useContext(MultiScreenReceiverContext);
}

function WithMultiScreenReceiver(props: React.PropsWithChildren<{ presentationReceiver: PresentationReceiver }>) {
    const { presentationReceiver } = props;

    const receiver = useMemo(() => new MultiScreenReceiver(presentationReceiver), [presentationReceiver]);

    return (
        <MultiScreenReceiverContext.Provider value={receiver}>
            {props.children}
        </MultiScreenReceiverContext.Provider>
    );
}

export const withMultiScreenReceiver = (presentationReceiver: PresentationReceiver) =>
    // eslint-disable-next-line react/display-name
    (node: JSX.Element) =>
        <WithMultiScreenReceiver presentationReceiver={presentationReceiver}>{node}</WithMultiScreenReceiver>;
